var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11489_69053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 40,
    height: 40,
    rx: 8,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#D0D5DD",
    style: {
      stroke: "#D0D5DD",
      stroke: "color(display-p3 0.8144 0.8349 0.8656)",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6001 18H30.4001M13.6001 24H30.4001M21.4999 12C19.8153 14.6996 18.9221 17.8179 18.9221 21C18.9221 24.1821 19.8153 27.3004 21.4999 30M22.5 12C24.1847 14.6996 25.0778 17.8179 25.0778 21C25.0778 24.1821 24.1847 27.3004 22.5 30M13 21C13 22.1819 13.2328 23.3522 13.6851 24.4442C14.1374 25.5361 14.8003 26.5282 15.636 27.364C16.4718 28.1997 17.4639 28.8626 18.5558 29.3149C19.6478 29.7672 20.8181 30 22 30C23.1819 30 24.3522 29.7672 25.4442 29.3149C26.5361 28.8626 27.5282 28.1997 28.364 27.364C29.1997 26.5282 29.8626 25.5361 30.3149 24.4442C30.7672 23.3522 31 22.1819 31 21C31 18.6131 30.0518 16.3239 28.364 14.636C26.6761 12.9482 24.3869 12 22 12C19.6131 12 17.3239 12.9482 15.636 14.636C13.9482 16.3239 13 18.6131 13 21Z",
    stroke: "#344054",
    style: {
      stroke: "#344054",
      stroke: "color(display-p3 0.2053 0.2525 0.3280)",
      strokeOpacity: 1
    },
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11489_69053",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11489_69053"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11489_69053",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralButton);
export default __webpack_public_path__ + "static/media/referralButton.f231e66b693531f576f942f66ffe35e4.svg";
export { ForwardRef as ReactComponent };